import * as actionTypes from '../constants/index'

export const setPersonnelList = (list=[],data=[]) => {

    return {
        type: actionTypes.set_personnel_list,
        data: list,
        chooseData:data,
    }
};

export const updatePersonnelList = (value={}) => {
    return {
        type: actionTypes.update_personnel_list,
        data: value,
    }
};

//滚动分页时发起
export const addPersonnelList = (list=[],data=[]) => {
    return {
        type: actionTypes.add_personnel_list,
        data: list,
        chooseData:data,
    }
};


export const setPersonData = (data=[]) => {

    return {
        type: actionTypes.set_person_data,
        data: data,
    }
};

export const setChoosePerson = (value={}) => {

    return {
        type: actionTypes.set_choose_person,
        data: value,
    }
};

export const deleteChoosePerson = (value={}) => {

    return {
        type: actionTypes.delete_choose_person,
        data: value,
    }
};




